
/* rem 12/6/19
	var searchObj = {};
	var categories = [{name: "SLATE", id: 400, children: [425,450,475,495]},
						 {name: "CORE ELASTICITY", id: 425, children: [430,440]},
						  		  {name: "VERTICAL", id: 430, children: [431,432,433,434]},
										  {name: "CATCH", id: 431, children: []},
									  	  {name: "SLAM", id: 432, children: []},
									  	  {name: "THROW", id: 433, children: []},
									  	  {name: "COMBINATION", id: 434, children: []},

					  		  	  {name: "ROTATIONAL", id: 440, children: [441,442,443,444]},
									  	  {name: "CATCH", id: 441, children: []},
										  {name: "SLAM", id: 442, children: []},
										  {name: "THROW", id: 443, children: []},
										  {name: "COMBINATION", id: 444, children: []},

						  {name: "LOWER BODY ELASTICITY", id: 450, children: [455,465]},
								  {name: "BILATERAL", id: 455, children: [456,457]},
										  {name: "LINEAR", id: 456, children: []},
										  {name: "LATERAL & ROTATIONAL", id: 457, children: []},
								  {name: "UNILATERAL", id: 465, children: [466,467]},
										  {name: "LINEAR", id: 466, children: []},
										  {name: "LATERAL & ROTATIONAL", id: 467, children: []},
						  {name: "CLOSED CHAIN AGILITY", id: 475, children: [480,488]},
							  	  {name: "LINEAR", id: 480, children: [481,482,483,484,485]},
										  {name: "ACCELERATION & SPRINT", id: 481, children: []},
										  {name: "SLED", id: 482, children: []},
										  {name: "LADDERS", id: 483, children: []},
										  {name: "SLIDEBOARD", id: 484, children: []},
										  {name: "JUMP/HOP", id: 485, children: []},
								  {name: "LATERAL & COMBINATION", id: 488, children: [489,490,491,492,493]},
										  {name: "ACCELERATION & SPRINT", id: 489, children: []},
										  {name: "SLED", id: 490, children: []},
										  {name: "LADDERS", id: 491, children: []},
										  {name: "SLIDEBOARD", id: 492, children: []},
										  {name: "JUMP/HOP", id: 493, children: []},
					  	  {name: "OPEN CHAIN AGILITY", id: 495, children: []},
					{name: "STRENGTH", id: 500, children: [525,575,625,675]},
							  {name: "UPPER BODY STRENGTH", id: 525 , children: [530,535,540,545,550,555,560]},
									  {name: "BILATERAL UPPER BODY PUSH", id: 530, children: [531,532]},
											  {name: "HORIZONTAL", id: 531, children: []},
											  {name: "VERTICAL",   id: 532, children: []},
									  {name: "BILATERAL UPPER BODY PULL", id: 535, children: [536,537]},
											  {name: "HORIZONTAL", id: 536, children: []},
											  {name: "VERTICAL",   id: 537, children: []},
									  {name: "UNILATERAL UPPER BODY PUSH", id: 540, children: [541,542]},
											  {name: "HORIZONTAL", id: 541, children: []},
											  {name: "VERTICAL",   id: 542, children: []},
									  {name: "UNILATERAL UPPER BODY PULL", id: 545, children: [546,547]},
											  {name: "HORIZONTAL", id: 546, children: []},
											  {name: "VERTICAL",   id: 547, children: []},
									  {name: "ARMS", id: 550, children: [551,552]},
											  {name: "BICEPS", id: 551, children: []},
											  {name: "TRICEPS",id: 552, children: []},
									  {name: "COMBINATIONS", id: 555, children: []},
									  {name: "FOREARMS", 	 id: 560, children: []},

							   {name: "LOWER BODY STRENGTH", id: 575, children: [580,590,600,610]},
									  {name: "BILATERAL LOWER BODY PUSH", id: 580, children: []},
									  {name: "BILATERAL LOWER BODY PULL", id: 590, children: [591,592,593,594]},
											  {name: "VERTICAL TIBIA", 	id: 591, children: []},
											  {name: "STRAIGHT LEG", 	id: 592, children: []},
											  {name: "BENT LEG (CURL)", id: 593, children: []},
											  {name: "BENT LEGGED (HYPEREXTENSION)", id: 594, children: []},
									  {name: "UNILATERAL LOWER BODY PUSH", id: 600, children: [601,602,603]},
									  		  {name: "VERTICAL SUPPORTED",   id: 601, children: []},
											  {name: "HORIZONTAL SUPPORTED", id: 602, children: []},
											  {name: "UNSUPPORTED", 		 id: 603, children: []},
									  {name: "UNILATERAL LOWER BODY PULL", id: 610, children: [611,612,613,614]},
									  		  {name: "VERTICAL TIBIA", id: 611, children: []},
											  {name: "STRAIGHT LEG", id: 612, children: []},
											  {name: "BENT LEG (CURL)", id: 613, children: []},
											  {name: "BENT LEGGED (HYPEREXTENSION)", id: 614, children: []},
							  {name: "CORE STABILITY", id: 625, children: [635,645,655,665]},
									  {name: "TRANSVERSE (ANTI-ROTATION)", id: 635, children: [636,637,638,639,640]},
									  		  {name: "LIFT OR CHOP", id: 636, children: []},
											  {name: "PUSHOUTS", id: 637, children: []},
											  {name: "LANDMINE", id: 638, children: []},
											  {name: "KEISER PUSH PULL", id: 639, children: []},
											  {name: "PULL & PRESS CABLE BAR", id: 640, children: []},
									  {name: "SAGITTAL (ANTI-EXTENSION)", id: 645, children: [646,647]},
									  		  {name: "ROLLOUTS", id: 646 , children: []},
											  {name: "HANDLE",   id: 647, children: []},
									  {name: "COMBINATIONS", id: 655, children: []},
								   	  {name: "SEQUENCING (MOBILITY)", id: 665, children: []},
							  {name: "OLYMPIC & WEIGHTLIFTING", id: 675, children: [680,685,690,695,700,710]},
									  {name: "BILATERAL PUSH", 		   id: 680, children: []},
									  {name: "BILATERAL PULL", 	 	   id: 685, children: []},
									  {name: "BILATERAL COMBINATION",  id: 690, children: []},
									  {name: "UNILATERAL PUSH", 	   id: 695, children: []},
									  {name: "UNILATERAL PULL", 	   id: 700, children: []},
									  {name: "UNILATERAL COMBINATION", id: 710, children: []},
					{name: "FOAM ROLL", id: 100, children: [125,150]},
							  {name: "UPPER BODY", id: 125, children: []},
							  {name: "LOWER BODY", id: 150, children: []},
					{name: "CORRECTIVES", id: 300, children: [325,350,375,390,395]},
							  {name: "UPPER BODY", id: 325, children: [330,335,340]},
							  		  {name: "SHOULDER", id: 330, children: []},
									  {name: "ELBOW",    id: 335, children: []},
									  {name: "WRIST",    id: 340, children: []},
							  {name: "LOWER BODY", id: 350, children: [355,360,365]},
									  {name: "HIP & THIGH", id: 355, children: []},
									  {name: "KNEE", 		id: 360, children: []},
									  {name: "ANKLE", 		id: 365, children: []},
							  {name: "SPINE", id: 375, children: [380,385,388]},
									  {name: "CERVICAL", id: 380, children: []},
									  {name: "THORACIC", id: 385, children: []},
									  {name: "LUMBAR", 	 id: 388, children: []},
							  {name: "DIAPHRAGM & POSTURE", id: 390, children: []},
							  {name: "COMBINATIONS", id: 395, children: []},
					{name: "PREP", id: 200, children: [225,250,275]},
							  {name: "COMBINATION", id: 225, children: []},
							  {name: "UPPER BODY",  id: 250, children: []},
						  	  {name: "LOWER BODY",  id: 275, children: []}]*/

// Slate Ids 400-499
// Strength Ids: 500-799
// Foam Roll Ids: 100-199
// Correctives Ids: 300-399
// Prep Ids: 200-299

const ExerciseCategories = [{name: "SLATE", id: 400, children: [425,450,475,495]},
						 {name: "CORE ELASTICITY", id: 425, children: [430,440]},
						  		  {name: "VERTICAL", id: 430, children: [431,432,433,434]},
										  {name: "CATCH", id: 431, children: []},
									  	  {name: "SLAM", id: 432, children: []},
									  	  {name: "THROW", id: 433, children: []},
									  	  {name: "COMBINATION", id: 434, children: []},
					  		  	  {name: "ROTATIONAL", id: 440, children: [441,442,443,444]},
									  	  {name: "CATCH", id: 441, children: []},
										  {name: "SLAM", id: 442, children: []},
										  {name: "THROW", id: 443, children: []},
										  {name: "COMBINATION", id: 444, children: []},
						  {name: "LOWER BODY ELASTICITY", id: 450, children: [455,465]},
								  {name: "BILATERAL", id: 455, children: [456,457]},
										  {name: "LINEAR", id: 456, children: []},
										  {name: "LATERAL & ROTATIONAL", id: 457, children: []},
								  {name: "UNILATERAL", id: 465, children: [466,467]},
										  {name: "LINEAR", id: 466, children: []},
										  {name: "LATERAL & ROTATIONAL", id: 467, children: []},

						  {name: "CLOSED CHAIN AGILITY", id: 475, children: [480,488]},
							  	  {name: "LINEAR", id: 480, children: [481,482,483,484,485]},
										  {name: "ACCELERATION & SPRINT", id: 481, children: []},
										  {name: "SLED", id: 482, children: []},
										  {name: "LADDERS", id: 483, children: []},
										  {name: "SLIDEBOARD", id: 484, children: []},
										  {name: "JUMP/HOP", id: 485, children: []},
								  {name: "LATERAL & COMBINATION", id: 488, children: [489,490,491,492,493]},
										  {name: "ACCELERATION & SPRINT", id: 489, children: []},
										  {name: "SLED", id: 490, children: []},
										  {name: "LADDERS", id: 491, children: []},
										  {name: "SLIDEBOARD", id: 492, children: []},
										  {name: "JUMP/HOP", id: 493, children: []},
					  	  {name: "OPEN CHAIN AGILITY", id: 495, children: []},


					{name: "STRENGTH", id: 500, children: [525,575,625,675]},
							  {name: "UPPER BODY STRENGTH", id: 525 , children: [530,535,540,545,550,555,560]},
									  {name: "BILATERAL UPPER BODY PUSH", id: 530, children: [531,532]},
											  {name: "HORIZONTAL", id: 531, children: []},
											  {name: "VERTICAL",   id: 532, children: []},
									  {name: "BILATERAL UPPER BODY PULL", id: 535, children: [536,537]},
											  {name: "HORIZONTAL", id: 536, children: []},
											  {name: "VERTICAL",   id: 537, children: []},
									  {name: "UNILATERAL UPPER BODY PUSH", id: 540, children: [541,542]},
											  {name: "HORIZONTAL", id: 541, children: []},
											  {name: "VERTICAL",   id: 542, children: []},
									  {name: "UNILATERAL UPPER BODY PULL", id: 545, children: [546,547]},
											  {name: "HORIZONTAL", id: 546, children: []},
											  {name: "VERTICAL",   id: 547, children: []},
									  {name: "ARMS", id: 550, children: [551,552]},
											  {name: "BICEPS", id: 551, children: []},
											  {name: "TRICEPS",id: 552, children: []},
									  {name: "COMBINATIONS", id: 555, children: []},
									  {name: "FOREARMS", 	 id: 560, children: []},

							   {name: "LOWER BODY STRENGTH", id: 575, children: [580,590,600,610]},
									  {name: "BILATERAL LOWER BODY PUSH", id: 580, children: []},
									  {name: "BILATERAL LOWER BODY PULL", id: 590, children: [591,592,593,594]},
											  {name: "VERTICAL TIBIA", 	id: 591, children: []},
											  {name: "STRAIGHT LEG", 	id: 592, children: []},
											  {name: "BENT LEG (CURL)", id: 593, children: []},
											  {name: "BENT LEGGED (HYPEREXTENSION)", id: 594, children: []},
									  {name: "UNILATERAL LOWER BODY PUSH", id: 600, children: [601,602,603]},
									  		  {name: "VERTICAL SUPPORTED",   id: 601, children: []},
											  {name: "HORIZONTAL SUPPORTED", id: 602, children: []},
											  {name: "UNSUPPORTED", 		 id: 603, children: []},
									  {name: "UNILATERAL LOWER BODY PULL", id: 610, children: [611,612,613,614]},
									  		  {name: "VERTICAL TIBIA", id: 611, children: []},
											  {name: "STRAIGHT LEG", id: 612, children: []},
											  {name: "BENT LEG (CURL)", id: 613, children: []},


											  {name: "BENT LEGGED (HYPEREXTENSION)", id: 614, children: []},
							  {name: "CORE STABILITY", id: 625, children: [635,645,655,665]},
									  {name: "TRANSVERSE (ANTI-ROTATION)", id: 635, children: [636,637,638,639,640]},
									  		  {name: "LIFT OR CHOP", id: 636, children: []},
											  {name: "PUSHOUTS", id: 637, children: []},
											  {name: "LANDMINE", id: 638, children: []},
											  {name: "KEISER PUSH PULL", id: 639, children: []},
											  {name: "PULL & PRESS CABLE BAR", id: 640, children: []},
									  {name: "SAGITTAL (ANTI-EXTENSION)", id: 645, children: [646,647]},
									  		  {name: "ROLLOUTS", id: 646 , children: []},
											  {name: "HANDLE",   id: 647, children: []},
									  {name: "COMBINATIONS", id: 655, children: []},
								   	  {name: "SEQUENCING (MOBILITY)", id: 665, children: []},
							  {name: "OLYMPIC & WEIGHTLIFTING", id: 675, children: [680,685,690,695,700,710]},
									  {name: "BILATERAL PUSH", 		   id: 680, children: []},
									  {name: "BILATERAL PULL", 	 	   id: 685, children: []},
									  {name: "BILATERAL COMBINATION",  id: 690, children: []},
									  {name: "UNILATERAL PUSH", 	   id: 695, children: []},
									  {name: "UNILATERAL PULL", 	   id: 700, children: []},
									  {name: "UNILATERAL COMBINATION", id: 710, children: []},


					{name: "FOAM ROLL", id: 100, children: [125,150]},
							  {name: "UPPER BODY", id: 125, children: []},
							  {name: "LOWER BODY", id: 150, children: []},

					{name: "CORRECTIVES", id: 300, children: [325,350,375,390,395]},
							  {name: "UPPER BODY", id: 325, children: [330,335,340]},
							  		  {name: "SHOULDER", id: 330, children: []},
									  {name: "ELBOW",    id: 335, children: []},
									  {name: "WRIST",    id: 340, children: []},
							  {name: "LOWER BODY", id: 350, children: [355,360,365]},
									  {name: "HIP & THIGH", id: 355, children: []},
									  {name: "KNEE", 		id: 360, children: []},
									  {name: "ANKLE", 		id: 365, children: []},
							  {name: "SPINE", id: 375, children: [380,385,388]},
									  {name: "CERVICAL", id: 380, children: []},
									  {name: "THORACIC", id: 385, children: []},
									  {name: "LUMBAR", 	 id: 388, children: []},
							  {name: "DIAPHRAGM & POSTURE", id: 390, children: []},
							  {name: "COMBINATIONS", id: 395, children: []},

					{name: "PREP", id: 200, children: [225,250,275]},
							  {name: "COMBINATION", id: 225, children: []},
							  {name: "UPPER BODY",  id: 250, children: []},
						  	  {name: "LOWER BODY",  id: 275, children: []}]

export default ExerciseCategories;



// WEBPACK FOOTER //
// ./src/utils/ExerciseMatrixCategories.js